/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendMessageToThreadRequestMessagesInner
 */
export interface SendMessageToThreadRequestMessagesInner {
    /**
     * The message content
     * @type {string}
     * @memberof SendMessageToThreadRequestMessagesInner
     */
    content?: string;
    /**
     * The role of the message sender
     * @type {string}
     * @memberof SendMessageToThreadRequestMessagesInner
     */
    role?: SendMessageToThreadRequestMessagesInnerRoleEnum;
}


/**
 * @export
 */
export const SendMessageToThreadRequestMessagesInnerRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;
export type SendMessageToThreadRequestMessagesInnerRoleEnum = typeof SendMessageToThreadRequestMessagesInnerRoleEnum[keyof typeof SendMessageToThreadRequestMessagesInnerRoleEnum];


/**
 * Check if a given object implements the SendMessageToThreadRequestMessagesInner interface.
 */
export function instanceOfSendMessageToThreadRequestMessagesInner(value: object): value is SendMessageToThreadRequestMessagesInner {
    return true;
}

export function SendMessageToThreadRequestMessagesInnerFromJSON(json: any): SendMessageToThreadRequestMessagesInner {
    return SendMessageToThreadRequestMessagesInnerFromJSONTyped(json, false);
}

export function SendMessageToThreadRequestMessagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageToThreadRequestMessagesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'] == null ? undefined : json['content'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

  export function SendMessageToThreadRequestMessagesInnerToJSON(json: any): SendMessageToThreadRequestMessagesInner {
      return SendMessageToThreadRequestMessagesInnerToJSONTyped(json, false);
  }

  export function SendMessageToThreadRequestMessagesInnerToJSONTyped(value?: SendMessageToThreadRequestMessagesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'role': value['role'],
    };
}

